<template>
  <div class="index">
    <div class="itemBox">
      <div
        class="item"
        v-for="(item, index) in dataList"
        :key="item + index"
        @click="clickToPage(item)"
      >
        <div class="num">
          <span class="numfont" style="font-size: 30px">{{item.name == "项目数量"? total2:'' }}</span>
          <span class="numfont" style="font-size: 30px">{{item.name == "活动数量"? total1:'' }}</span>
          <span class="numfont" style="font-size: 30px">{{item.name == "访问人数"? message:'' }}</span>
          <span>{{ item.name == "访问人数" ? "人" : "个" }}</span>
          <!-- <span v-else>人</span> -->
        </div>
        <div class="content">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
     return{
       total1:'',
       total2:'',
     }
  },
  props: {
    message:{},
    dataList: {
      type: Array,
      default: function () {
        return [
          {
            name: "项目数量",
            num: "",
          },
          {
            name: "活动数量",
            num: "",
          },
          {
            name: "访问人数",
            num: "",
          },

        ];
      },
    },
  },
  mounted(){
     this.getList1()
     this.getList2()
  },
  methods: {
    clickToPage(item) {
      console.log(item);
      if (item.name == "项目数量") {
        this.$router.push("/project");
      } else if (item.name == "活动数量") {
        this.$router.push("/servers");
      }
    },
    // 获取列表
    getList1 () {
      let url =
        this.$baseUrl + "/teamword/wechat/kyyProject/selectKyyActivityPageList";
      let postData = {
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.total1 = res.data.total;
        })
        .catch(() => { });
    },
        // 获取数据列表
    getList2 () {
      let url =
        this.$baseUrl + "/teamword/wechat/kyyProject/selectKyyProjectByGovId";
      let postData = {
      };
      this.postRequest(url, postData)
        .then((res) => {
          this.total2 = res.data.pageInfo.total;
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  cursor: default;
  transform: translateY(10px);
  width: 95%;
  margin-left: 5%;
  height: 90px;
  .itemBox {
    width: 100%;
    display: flex;
    color: #fff;
    justify-content: space-between;
    .item {
      cursor: pointer;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 27%;
      height: 70px;
      background: url("../../../assets/images/pageHome/msgItem.png") no-repeat
        center/100% 100%;
      .num {
        font-weight: bold;
        transform: translateY(-20px);
        .numfont {
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #fff;
        }
      }
      .content {
        transform: translateY(-18px);
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
</style>
